export default __webpack_public_path__ + "static/media/logo.120f1f4e.png";